import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useParams, useNavigate } from "react-router-dom";
import { baseUrl, userName, ipAddress, userLocation } from "../Univ.js";

function EditMaintenance() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [machines, setMachines] = useState([]);
  const [data, setData] = useState({
    machine_id: "",
    description: "",
    maintenance_date: "",
    cost: "0"
  });

  useEffect(() => {
    fetchMaintenance();
    fetchMachines();
  }, []);

  const fetchMaintenance = () => {
    axios.get(baseUrl + "maintenance/" + id + "/")
      .then(res => {
        setData({
          machine_id: res.data.machine?.id || "",
          description: res.data.description,
          maintenance_date: res.data.maintenance_date,
          cost: res.data.cost
        });
      })
      .catch(() => Swal.fire("Error", "Could not fetch Maintenance", "error"));
  };

  const fetchMachines = () => {
    axios.get(baseUrl + "machines/")
      .then(res => setMachines(res.data));
  };

  const inputHandler = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const formSubmit = () => {
    if (!data.machine_id || !data.description || !data.maintenance_date) {
      Swal.fire("Error", "Machine, Description, and Date are required", "error");
      return;
    }

    const _formData = new FormData();
    _formData.append("machine", data.machine_id);
    _formData.append("description", data.description);
    _formData.append("maintenance_date", data.maintenance_date);
    _formData.append("cost", data.cost || 0);
    _formData.append("status", "1");
    _formData.append("addedby", userName);
    _formData.append("ip_add", ipAddress);
    _formData.append("location", userLocation);

    axios.put(baseUrl + "maintenance/" + id + "/", _formData, {
      headers: { "Content-Type": "multipart/form-data" }
    })
    .then(response => {
      if (response.status === 200) {
        Swal.fire({
          title: "Maintenance Updated",
          icon: "success",
          timer: 2000,
          showConfirmButton: false
        });
        setTimeout(() => navigate('/maintenance'), 2000);
      }
    })
    .catch(() => Swal.fire("Error", "Update failed", "error"));
  };

  return (
    <div className="container mt-4">
      <div className="card p-4">
        <h4>Edit Machine Maintenance</h4>

        <select
          className="form-control mt-3"
          name="machine_id"
          value={data.machine_id}
          onChange={inputHandler}
        >
          <option value="">Select Machine</option>
          {machines.map(m => (
            <option key={m.id} value={m.id}>{m.name}</option>
          ))}
        </select>

        <textarea
          className="form-control mt-3"
          placeholder="Description"
          name="description"
          value={data.description}
          onChange={inputHandler}
        />

        <input
          type="date"
          className="form-control mt-3"
          name="maintenance_date"
          value={data.maintenance_date}
          onChange={inputHandler}
        />

        <input
          type="number"
          className="form-control mt-3"
          placeholder="Cost"
          name="cost"
          value={data.cost}
          onChange={inputHandler}
        />

        <button className="btn btn-primary mt-3" onClick={formSubmit}>
          Update
        </button>
      </div>
    </div>
  );
}

export default EditMaintenance;
